import React, { Component } from "react";
import { connect } from "react-redux";
import * as qs from "query-string";
import { history } from "../../_helpers";
import { api } from "../../_services";
import L from "leaflet";
import "leaflet.markercluster";
import { Link } from "react-router-dom";
import { Button, FormGroup, ControlLabel, Badge } from "react-bootstrap";
import MenuBar from "../MenuBar";
import FilterMenuBar from "../FilterMenuBar";
import {
  sensorList,
  pageDevices,
  filteredSensorDataList,
  getSensorData,
  sensorId,
  sidebarOn,
  sidebarOff
} from "../../_actions";
import FontAwesome from "react-fontawesome";
import LineGraph from "../LineGraph";
import _ from "lodash";
import "./index.css";
import Select from "react-select";
import "react-select/dist/react-select.css";

import PrecinctDropdown from "../PrecinctDropdown";
import SensorTypeCheckBox from "../SensorTypeCheckBox";
import DeviceStatusCheckBox from "../DeviceStatusCheckBox";

const center = [-37.814, 144.96332];
const today = new Date();
const initialStartDate = new Date(new Date().setDate(today.getDate() - 1));

const railLineStyle = {
  color: "#00bad4",
  weight: 1.5
};

const stationBoxStyle = {
  color: "#e52923",
  fillColor: "#e52923",
  weight: 1,
  fillOpacity: 0.9
};

class AllSensorMap extends Component {
  constructor(props) {
    super(props);
    this.state = {
      devicesList: [],
      currentDevice: null,
      filterOpen: false,
      sidePanelOpen: false,
      telemetrySets: [],
      seriesList: [],
      telemetryTypeInput: "",
      activeSeriesIndex: 0,
      params: {}
    };
  }

  componentDidMount() {
    //set current page to map
    this.props.pageDevices();
    this.setCurrentPage(false);

    fetch("data/rail_centreline.geojson")
      .then(response => {
        return response.json();
      })
      .then(json => {
        fetch("data/stationBoxes_polygon.geojson")
          .then(response => {
            return response.json();
          })
          .then(json1 => {
            this.setState(() => {
              return {
                railLineGeojson: json,
                stationBoxGeojson: json1
              };
            });
          });
      })
      .then(() => {
        if (this.props.location.search) {
          const params = qs.parse(this.props.location.search);
          this.getAllSensors(params);
        } else {
          this.getAllSensors();
        }
      });

  }

  componentWillUnmount() {
    if (this.state.map !== undefined) {
      this.state.map.remove();
    }
  }

  setTelemetryType = tempList => {
    if (!tempList) {
      return;
    }

    const tmpTypes = [];
    if (tempList.telemetry_sets.length > 0) {
      _.each(tempList.telemetry_sets, value => {
        const foundItem = _.find(this.props.configList.telemetry_types, item => {
          return item.type_id.search(value.telemetry_type_id) !== -1;
        });

        tmpTypes.push({
          id: tempList.telemetry_sets.indexOf[value],
          telemetry_type: foundItem.name,
          telemetry_type_id: foundItem.type_id
        });
      });

      if (tmpTypes.length > 0) {
        this.setState(() => {
          return {
            telemetryTypeInput: tmpTypes[0].telemetry_type_id,
            telemetrySets: tmpTypes
          };
        });
      }
    }
  };

  setCurrentPage = (val) => {
    localStorage.setItem("currentDevicePageType", JSON.stringify({ list: val }));
  }

  /* Method to get the device data */
  getTelemetrySets = id => {
    const url = "/api/v1/devices/" + id + "/";
    const errorMsg = "Unable to get the device data.";
    api
      .getFetch(url, "", this.props.user.token, errorMsg)
      .then(json => {
        //set the device details to the state
        this.setState(() => {
          return {
            telemetryCheck: json.telemetry_sets.length > 0 ? true : false,
            deviceDetails: json
          };
        });
        return json;
      })
      .then(json => {
        this.setTelemetryType(json);
        return json;
      })
      .then(() => {
        this.filterSeries(this.state.telemetryTypeInput);
      });
  };

  /* Method to filter the data based on the selected telemetry type */
  filterSeries = selectedTelemetryType => {
    const tmpSeriesTypes = [];
    let filteredTypeItem = [];

    if (selectedTelemetryType.length > 0) {
      filteredTypeItem = this.props.configList.telemetry_types.filter(item => {
        return item.type_id.search(selectedTelemetryType) !== -1;
      });
    }

    if (filteredTypeItem.length > 0) {
      if (filteredTypeItem[0].series_list.length > 0) {
        for (let i = 0; i < filteredTypeItem[0].series_list.length; i++) {
          tmpSeriesTypes.push({
            id: i,
            series_type: filteredTypeItem[0].series_list[i].short_name,
            series_id: filteredTypeItem[0].series_list[i].series_id
          });
        }
      }
    }
    this.setState(() => {
      return {
        seriesList: tmpSeriesTypes
      };
    });
  };

  closeSidebar = () => {
    this.setState(() => {
      return {
        sidePanelOpen: false
      };
    });
    this.resetMarker();
    this.props.sidebarOff();
  };

  /* Function to get all the devices */
  getAllSensors = p => {
    const url = "/api/v1/devices/";
    const params = {};
    if (p) {
      for (const key in p) {
        params[key] = p[key];
      }
      this.setState(() => {
        return {
          params: params
        };
      });
    } else {
      // clear the url params
      if (this.props.location.search) {
        history.push({
          pathname: this.props.location.pathname,
          search: ""
        });
      }
    }
    const errorMsg = "Unable to get devices list.";
    api
      .getFetch(url, params, this.props.user.token, errorMsg)
      .then(json => {
        const filtered = this.checkFiltered();
        this.setState(() => {
          return {
            devicesList: json.results,
            count: json.count,
            page_size: json.page_size,
            num_pages: json.num_pages,
            current_page: json.current_page,
            filtered: filtered
          };
        });
      })
      .then(() => {
        //check if map container exist
        const mapEle = document.getElementById("map");
        if (mapEle !== null && !this.state.map) {
          this.initMap();
        } else if (this.state.map) {
          this.renderMarkers();
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  filterDevice = reset => {
    const url = "/api/v1/devices/";
    const params = {};
    if (!reset) {
      for (const key in this.state.params) {
        if (
          this.state.params[key] !== "" &&
          (Array.isArray(this.state.params[key]) && this.state.params[key].length !== 0)
        ) {
          params[key] = this.state.params[key];
        } else if (
          this.state.params[key] === "" ||
          (Array.isArray(this.state.params[key]) && this.state.params[key].length === 0)
        ) {
          delete this.state.params[key];
        }
      }
    }
    if (this.checkFiltered() || !reset) {
      const errorMsg = "Unable to retrieve devices.";
      let filtered = false;

      filtered = this.checkFiltered();

      api.getFetch(url, params, this.props.user.token, errorMsg).then(json => {
        this.setState(() => {
          return {
            devicesList: json.results,
            count: json.count,
            page_size: json.page_size,
            num_pages: json.num_pages,
            current_page: json.current_page,
            loading: false,
            listLoading: false,
            filtered: filtered ? true : false
          };
        });
        this.renderMarkers();
      });
      this.openFilter(false);
    } else if (reset) {
      this.setState(() => {
        return {
          loading: false,
          filtered: reset ? false : true
        };
      });
    }

    const queryParams = api.queryParams(params);
    if (queryParams) {
      history.push({
        pathname: this.props.location.pathname,
        search: "?" + queryParams
      });
    } else {
      history.push({
        pathname: this.props.location.pathname,
        search: ""
      });
    }
  };

  checkFiltered = () => {
    let filtered = false;
    for (const key in this.state.params) {
      if (Array.isArray(this.state.params[key]) && this.state.params[key].length > 0) {
        filtered = true;
      } else if (this.state.params[key]) {
        filtered = true;
      }
    }
    return filtered;
  };

  getStatusName = val => {
    let device_statuses;
    if (this.props.configList.device_statuses) {
      this.props.configList.device_statuses.forEach(function (item) {
        if (val === item.status) {
          device_statuses = item;
        }
      });
    }
    return device_statuses;
  };

  /* Function to handle feature click on layers */
  onEachFeature = (feature, layer) => {
    //bind click on each feature to open a sidebar
    layer.on({
      click: this.onMarkerClick
    });

    //bind tooltip on hovering over a feature
    if (feature.properties.type === "device") {
      const device_statuses = this.getStatusName(feature.properties.status);
      const str =
        "<div><b class='tooltip-name'>" +
        feature.properties.name +
        "</b><div class='tooltip-con'><b>Device Type:</b> " +
        feature.properties.deviceType +
        "<br><b>Status:</b> " +
        (device_statuses ? device_statuses.display_name : "") +
        "</div></div>";

      layer.bindTooltip(str, { offset: L.point({ x: 0, y: -18 }) });
    } else {
      layer.bindTooltip(feature.properties.name);
    }
  };

  /* function to handle sidebars on marker click */
  onMarkerClick = e => {
    this.setState(() => {
      return {
        sidePanelOpen: false,
        telemetryCheck: false
      };
    });
    const setDeviceIcon = this.setDeviceIcon;
    this.state.deviceClusterLayer.eachLayer(function (marker) {
      if (e.target.feature.properties.id !== marker.feature.properties.id) {
        const markerIcon = setDeviceIcon(marker.feature, true);
        marker.setIcon(markerIcon);
      } else {
        const markerIcon = setDeviceIcon(marker.feature, false);
        marker.setIcon(markerIcon);
      }
    });
    this.setState(() => {
      return {
        currentDevice: e.target.feature.properties,
        sidePanelOpen: true,
        activeSeriesIndex: 0
      };
    });
    this.state.map.setView(e.target.getLatLng());
    this.getTelemetrySets(e.target.feature.properties.id);
    this.getSensorData(e.target.feature.properties.id);
    this.props.sensorId(e.target.feature.properties.id);
  };

  /* Method to get the device's telemetry data */
  getSensorData = id => {
    const url = "/api/v1/devices/" + id + "/telemetry/";
    const params = {
      start_time: initialStartDate.toISOString(),
      end_time: today.toISOString(),
      max_records: 1440
    };
    const errorMsg = "Unable to get sensor data.";
    api.getFetch(url, params, this.props.user.token, errorMsg).then(json => {
      if (json.telemetry_sets !== undefined && json.telemetry_sets.length > 0) {
        const tmpFilteredData = [];
        tmpFilteredData.push(json.telemetry_sets[0].columns[0], json.telemetry_sets[0].columns[1]);

        this.props.filteredSensorDataList(tmpFilteredData);
        this.props.getSensorData(json.telemetry_sets);
      }
      this.props.sidebarOn(json);
    });
  };

  resetMarker = () => {
    const setDeviceIcon = this.setDeviceIcon;
    this.state.deviceClusterLayer.eachLayer(function (marker) {
      const markerIcon = setDeviceIcon(marker.feature, false);
      marker.setIcon(markerIcon);
    });
  };

  renderSidePanelPrecincts = () => {
    if (this.state.currentDevice.precincts.length > 0) {
      return (
        <div>
          <label>Precinct:&nbsp;</label>
          {this.state.currentDevice.precincts.map((item, index) => {
            return (
              <span key={item.id}>
                {index > 0 ? ", " : null}
                {item.name}
              </span>
            );
          })}
        </div>
      );
    } else {
      return null;
    }
  };

  renderSeriesList = () => {
    if (this.state.seriesList) {
      return (
        <FormGroup controlId="formControlsSelect">
          <ControlLabel>Series</ControlLabel>
          <Select
            name="series-list"
            value={this.state.activeSeriesIndex}
            onChange={this.handleSeriesChange}
            valueKey="id"
            labelKey="series_type"
            options={this.state.seriesList}
            clearable={false}
          />
        </FormGroup>
      );
    }
  };

  renderGraphScreen = (telemetryCheck, seriesList, deviceDetails) => {
    if (telemetryCheck && seriesList && deviceDetails) {
      return (
        <div className="graphPanel">
          <h3>
            <FontAwesome name="clock" /> Today
          </h3>
          {this.renderSeriesList()}
          <LineGraph height={250} refreshInterval={5000} maxRecords={1440} seriesIndex={this.state.activeSeriesIndex} />
        </div>
      );
    } else {
      return (
        <div className="graphPanel">
          <p>
            The MLM is not currently configured to receive data from this device. For more information, please contact a
            member of the MLM team.
          </p>
        </div>
      );
    }
  };

  renderSidePanel = () => {
    const { seriesList, deviceDetails, telemetryCheck } = this.state;
    const { sensorDataList } = this.props;
    if (this.state.sidePanelOpen === true) {
      return (
        <div className="side-panel-con">
          <a className="btn-close" onClick={this.closeSidebar}>
            <FontAwesome name="times" />
          </a>
          <div className="panel-div side-panel">
            <h3>
              <FontAwesome name="cube" /> {this.state.currentDevice.name} (ID:&nbsp;{this.state.currentDevice.id})
            </h3>
            <div className={"status-" + this.state.currentDevice.status}>
              <FontAwesome name="circle" /> {this.state.currentDevice.status}
              <Link to={"/device/" + this.state.currentDevice.id} className="pull-right">
                View Device
              </Link>
            </div>
            {/*<div>
              Lorem Ipsum is simply dummy text of the printing and typesetting industry.
              Lorem Ipsum has been the industrys standard dummy text ever since the 1500s.
            </div>*/}
            {this.renderSidePanelPrecincts()}
            <div className="margin-btm">
              <label>Device type:</label> {this.state.currentDevice.deviceType}
            </div>
            {this.renderGraphScreen(telemetryCheck, seriesList, deviceDetails, sensorDataList)}
          </div>
        </div>
      );
    } else {
      return null;
    }
  };

  renderFilterPanel = () => {
    if (this.state.filterOpen === true) {
      return (
        <div className="panel-div filter-column">
          <div className="filterTitle">FILTER DEVICES {this.renderResetBtn()}</div>
          <form>
            <PrecinctDropdown
              change={this.setPrecinct}
              reset={this.state.resetFilter}
              defaultValue={this.state.params.precincts}
            />
            <SensorTypeCheckBox
              change={this.setSensorType}
              reset={this.state.resetFilter}
              defaultValue={this.state.params.disciplines}
            />
            <DeviceStatusCheckBox
              change={this.setStatus}
              reset={this.state.resetFilter}
              defaultValue={this.state.params.status}
            />
            <div className="buttonContainer">
              <Button className="btn-cancel" bsStyle="default" onClick={() => this.openFilter(false)}>
                Cancel
              </Button>
              <Button className="btn-filter" bsStyle="primary" onClick={() => this.filterDevice()}>
                Filter
              </Button>
            </div>
          </form>
        </div>
      );
    } else {
      return null;
    }
  };

  setStatus = val => {
    const params = this.state.params;
    params.status = val;
    if (val !== params.status || this.state.resetFilter) {
      this.setState(() => {
        return {
          params: params,
          resetFilter: false
        };
      });
    }
  };

  setPrecinct = val => {
    const params = this.state.params;
    params.precincts = val;
    if (val !== params.precincts || this.state.resetFilter) {
      this.setState(() => {
        return {
          params: params,
          resetFilter: false
        };
      });
    }
  };

  setSensorType = val => {
    const params = this.state.params;
    params.disciplines = val;
    if (val !== params.disciplines || this.state.resetFilter) {
      this.setState(() => {
        return {
          params: params,
          resetFilter: false
        };
      });
    }
  };

  resetFilter = () => {
    this.setState(() => {
      return {
        resetFilter: true,
        params: {},
        showIDInput: false
      };
    });
    this.getAllSensors();
  };

  renderResetBtn = () => {
    if (this.state.filtered === true) {
      return (
        <a className="pull-right link" onClick={() => this.resetFilter()}>
          Reset filters
        </a>
      );
    } else {
      return null;
    }
  };

  renderFilterBadge = () => {
    const obj = this.state.params;
    let count = 0;
    let key;
    for (key in obj) {
      if (obj.hasOwnProperty(key) && (Array.isArray(obj[key]) && obj[key].length > 0)) {
        count++;
      } else if (obj.hasOwnProperty(key) && obj[key] !== "") {
        count++;
      }
    }

    if (this.state.filtered === true) {
      return <Badge>{count} &times;</Badge>;
    } else {
      return null;
    }
  };

  openFilter = () => {
    this.setState(() => {
      return {
        filterOpen: !this.state.filterOpen
      };
    });
  };

  pointToLayer = (feature, latlng) => {
    return L.marker(latlng, { icon: this.setDeviceIcon(feature) });
  };

  setDeviceIcon = (e, state) => {
    let deviceIcon = null;
    let deviceBg = null;
    let deviceIcon2x = null;
    let deviceBg2x = null;
    // marker shadow change base on status.
    if (e.properties.status === "online") {
      deviceBg = require("../../_images/sensor-bg-online.png");
      deviceBg2x = require("../../_images/sensor-bg-online-2x.png");
    } else if (e.properties.status === "offline") {
      deviceBg = require("../../_images/sensor-bg-offline.png");
      deviceBg2x = require("../../_images/sensor-bg-offline-2x.png");
    } else if (e.properties.status === "retired") {
      deviceBg = require("../../_images/sensor-bg-retired.png");
      deviceBg2x = require("../../_images/sensor-bg-retired-2x.png");
    } else if (e.properties.status === "unmonitored") {
      deviceBg = require("../../_images/sensor-bg-unmonitored.png");
      deviceBg2x = require("../../_images/sensor-bg-unmonitored-2x.png");
    } else {
      deviceBg = require("../../_images/sensor-bg-unmonitored.png");
      deviceBg2x = require("../../_images/sensor-bg-unmonitored-2x.png");
    }
    // marker icon can change base on device icon.
    if (e.properties.icon === "microphone") {
      deviceIcon = require("../../_images/sensor-noise.png");
      deviceIcon2x = require("../../_images/sensor-noise-2x.png");
    } else if (e.properties.icon === "vibration") {
      deviceIcon = require("../../_images/sensor-vibrate.png");
      deviceIcon2x = require("../../_images/sensor-vibrate-2x.png");
    } else if (e.properties.icon === "air_quality") {
      deviceIcon = require("../../_images/sensor-air.png");
      deviceIcon2x = require("../../_images/sensor-air-2x.png");
    } else if (e.properties.icon === "multiple_sensors") {
      deviceIcon = require("../../_images/sensor-multiple.png");
      deviceIcon2x = require("../../_images/sensor-multiple-2x.png");
    } else {
      deviceIcon = require("../../_images/device-sensor.png");
      deviceIcon2x = require("../../_images/device-sensor-2x.png");
    }
    let markerClass = "markerOnfocus";
    if (state) {
      markerClass = "markerOutfocus";
    }

    return L.icon({
      iconUrl: deviceIcon,
      iconRetinaUrl: deviceIcon2x,
      shadowUrl: deviceBg,
      shadowRetinaUrl: deviceBg2x,
      iconSize: [24, 30],
      shadowSize: [24, 30],
      // marker point at the bottom center.
      iconAnchor: [12, 29],
      className: markerClass
    });
  };

  initMap = () => {
    const basemap = L.map("map", { zoomControl: true }).setView(center, 14);
    // set map control location
    basemap.zoomControl.setPosition("bottomright");

    //Setting the base layer for the map
    L.tileLayer("https://cartodb-basemaps-{s}.global.ssl.fastly.net/light_all/{z}/{x}/{y}.png", {
      attribution: `&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>
          &copy; <a href="http://cartodb.com/attributions">CartoDB</a>`,
      subdomains: "abcd",
      maxZoom: 19
    }).addTo(basemap);

    //Adding rail line to the map layer
    L.geoJSON(this.state.railLineGeojson, {
      style: railLineStyle
    }).addTo(basemap);

    //Adding station boxes to the map layer
    L.geoJSON(this.state.stationBoxGeojson, {
      style: stationBoxStyle
    }).addTo(basemap);

    // set the map object
    this.setState(() => {
      return {
        map: basemap
      };
    });

    this.renderMarkers();
  };

  renderMarkers = () => {
    const { devicesList, map } = this.state;
    let devicesPoints = {};

    //create list of feature points for devices
    if (devicesList !== undefined && devicesList.length > 0) {
      devicesPoints = devicesList.filter(d => d.location).map(d => ({
        type: "Feature",
        properties: {
          id: d.id,
          type: "device",
          name: d.name,
          deviceType: d.device_type_display,
          status: d.status,
          icon: d.icon,
          precincts: d.precincts,
          device_type_display: d.device_type_display
        },
        geometry: {
          type: "Point",
          coordinates: [d.location.longitude, d.location.latitude]
        }
      }));
    }

    //Adding the devices layer from the geojson
    const devicesLayer = L.geoJSON(
      {
        type: "FeatureCollection",
        features: devicesPoints
      },
      {
        pointToLayer: this.pointToLayer,
        onEachFeature: this.onEachFeature
      }
    );

    if (this.state.deviceClusterLayer) {
      map.removeLayer(this.state.deviceClusterLayer);
    }
    //generating the cluster layers for devices
    const devicemarkers = L.markerClusterGroup({
      maxClusterRadius: 50,
      iconCreateFunction: function (cluster) {
        return L.divIcon({
          html: "<div><span>" + cluster.getChildCount() + "</span></div>",
          iconSize: [40, 40],
          className: "marker-cluster-small marker-cluster",
        });
      },
    });
    devicemarkers.addLayer(devicesLayer);

    //adding the devices cluster layer
    map.addLayer(devicemarkers);

    // set the marker object
    this.setState(() => {
      return {
        deviceClusterLayer: devicemarkers
      };
    });
  };

  /* Method to filter the data based on the selected telemetry type */
  filterSeries = selectedTelemetryType => {
    const tmpSeriesTypes = [];
    let filteredTypeItem = [];

    if (selectedTelemetryType.length > 0) {
      filteredTypeItem = this.props.configList.telemetry_types.filter(item => {
        return item.type_id.search(selectedTelemetryType) !== -1;
      });
    }

    if (filteredTypeItem.length > 0) {
      if (filteredTypeItem[0].series_list.length > 0) {
        for (let i = 0; i < filteredTypeItem[0].series_list.length; i++) {
          tmpSeriesTypes.push({
            id: i,
            series_type: filteredTypeItem[0].series_list[i].short_name,
            series_id: filteredTypeItem[0].series_list[i].series_id
          });
        }
      }
    }
    this.setState(() => {
      return {
        seriesList: tmpSeriesTypes
      };
    });
  };

  /* Method the data based on the selected telemetry type */
  handleSeriesChange = e => {
    const val = e.series_id;
    const tmpFilteredData = [];
    tmpFilteredData.push(this.props.sensorDataList[0].columns[0]);
    for (let i = 0; i < this.props.sensorDataList[0].columns.length; i++) {
      if (this.props.sensorDataList[0].columns[i].id === val) {
        this.setState({
          activeSeriesIndex: i - 1
        });

        tmpFilteredData.push(this.props.sensorDataList[0].columns[i]);
      }
    }
    this.props.filteredSensorDataList(tmpFilteredData);
  };

  render() {
    return (
      <div>
        <MenuBar />
        <FilterMenuBar />
        <div className="map-container">
          <div className="layerContainer">
            <div className="btnCon pull-right">
              <Button
                bsStyle="primary"
                className={"pull-left" + (this.state.filterOpen ? " active" : "")}
                onClick={() => this.openFilter()}
              >
                Filter {this.renderFilterBadge()}
              </Button>
              <Link to={"/devices"} className="btn btn-primary pull-left" onClick={() => this.setCurrentPage(true)}>
                <FontAwesome name="list-ul" /> List View
              </Link>
            </div>
            {this.renderSidePanel()}
            {this.renderFilterPanel()}
          </div>
          <div id="map" />
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { users, authentication } = state;
  const { user } = authentication;
  const { configList } = state.configuration;
  const { list, id, sensorDataList } = state.sensordata;
  return {
    user,
    users,
    list,
    id,
    configList,
    sensorDataList
  };
}

export default connect(mapStateToProps, {
  filteredSensorDataList,
  getSensorData,
  sensorId,
  sensorList,
  pageDevices,
  sidebarOn,
  sidebarOff
})(AllSensorMap);



// WEBPACK FOOTER //
// ./src/_components/AllSensorMap/index.js